(function () {
  function sectionsParam() {
    try {
      if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && typeof Alpine.store('xCartHelper').getSectionsToRender === 'function') {
        return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) {}
    return [];
  }

  function addToCart(variantId, button) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var body = {
      items: [{ id: Number(variantId), quantity: 1 }]
    };
    var sections = sectionsParam();
    if (sections.length) body.sections = sections;

    button.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (response) {
        try {
          if (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) {
            if (response.sections) Alpine.store('xCartHelper').reRenderSections(response.sections);
            var bubble = document.querySelector('#cart-icon-bubble span');
            if (bubble) Alpine.store('xCartHelper').currentItemCount = parseInt(bubble.innerHTML, 10);
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        if (window.Alpine && Alpine.store && Alpine.store('xMiniCart') && typeof Alpine.store('xMiniCart').openCart === 'function') {
          Alpine.store('xMiniCart').openCart();
        }
      })
      .catch(function () {
        button.disabled = false;
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  function init(root) {
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-amc-camp-atc]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, btn);
    });
  }

  function boot() {
    document.querySelectorAll('[data-amc-campaign-bestsellers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
